

import innovationVolume from './innovationVolume'
import list from './list'

const securityService = {
  path: 'securityService',
  component: resolve => require(['../../../../pages/modules/securityService'], resolve),
  redirect: 'securityService/list',
  children: [
    innovationVolume,
    list
  ],
  meta: {
    requireAuth: true
  }
}

export default securityService
